import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Candles from "@/pages/Candles";
import Planters from "@/pages/Planters";
import Oils from "@/pages/Oils";
import Tshirts from "@/pages/Tshirts";
import Drinkware from "@/pages/Drinkware";
import BodyButter from "@/pages/BodyButter";
import BodyOil from "@/pages/BodyOil";
import Soaps from "@/pages/Soaps";
import Admin from "@/pages/Admin";
import Membership from "@/pages/Membership";
import Connect from "@/pages/Connect";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import SiteLayout from "@/components/SiteLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously (not in useEffect) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/candles" element={<Candles />} />
        <Route path="/shop/planters" element={<Planters />} />
        <Route path="/shop/oils" element={<Oils />} />
        <Route path="/shop/tshirts" element={<Tshirts />} />
        <Route path="/shop/drinkware" element={<Drinkware />} />
        <Route path="/shop/body-butter" element={<BodyButter />} />
        <Route path="/shop/body-oil" element={<BodyOil />} />
        <Route path="/shop/soaps" element={<Soaps />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-sans text-brand-ink">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
